// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseApi$Showside from "./UseApi.bs.js";
import * as Markets$Showside from "../types/Markets.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as StoreId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/Store/StoreId.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as PDPTypes$Showside from "../types/PDPTypes.bs.js";
import * as SWRUtils$Showside from "../utils/SWRUtils.bs.js";
import * as ArrayUtils$Showside from "../utils/ArrayUtils.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as StoreCategory$Showside from "../types/StoreCategory.bs.js";
import * as StoreProvider$Showside from "../context/StoreProvider.bs.js";
import * as QuickViewTypes$Showside from "../types/QuickViewTypes.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as UserSavedProductsContent$Showside from "../components/UserSavedProductsContent.bs.js";
import SmoothScrollIntoViewIfNeeded from "smooth-scroll-into-view-if-needed";
import * as IntermediateProductsResponse$Showside from "../types/IntermediateProductsResponse.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function isShopifyCollectionId(str) {
  return Belt_Option.isSome(Caml_option.null_to_opt(str.match(/^\d+$/)));
}
function useProductCategory(smartnavApiHost, storeId, productId, route, shouldFetch) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var settings = match$1.settings;
  var activeCategory = RouterProvider$Showside.useActiveCategory(true, undefined, match$1.categories);
  var match$2 = React.useState(function () {
    return activeCategory;
  });
  var setCurrentCategory = match$2[1];
  var currentCategory = match$2[0];
  var productCategoryId;
  if (typeof route === "number" || route.TAG !== /* PDP */2) {
    productCategoryId = undefined;
  } else {
    var productCategoryId$1 = route._0.productCategoryId;
    productCategoryId = productCategoryId$1 !== undefined && productCategoryId$1.trim() !== "" ? productCategoryId$1 : undefined;
  }
  var rootCategory = Belt_Option.keep(settings.indexNode, Category$Showside.ExternalConnection.isConnectedToStoreCategory);
  var match$3 = UseApi$Showside.useCategoriesByProduct(smartnavApiHost, storeId, activeCategory !== undefined || currentCategory !== undefined || rootCategory !== undefined ? undefined : productId, shouldFetch, undefined);
  var productCategories = Belt_Option.getWithDefault(Belt_Option.flatMap(match$3.data, function (page) {
    return page.categories;
  }), []);
  var match$4 = productCategories.length;
  var firstProductCategory = match$4 === 0 || match$4 === 1 ? Belt_Array.get(productCategories, 0) : ArrayUtils$Showside.getByPredicateOrFirst(Belt_Array.keep(productCategories, function (category) {
    return Curry._1(StoreId$ApiTypes.CategoryId.toString, category.id) !== "all";
  }), function (category) {
    return Caml_obj.equal(Curry._1(StoreId$ApiTypes.CategoryId.toString, category.id), productCategoryId);
  });
  var firstProductCategory$1 = React.useMemo(function () {
    return Belt_Option.map(firstProductCategory, function (param) {
      return StoreCategory$Showside.toShowsideCategory(settings, param);
    });
  }, [Belt_Option.map(firstProductCategory, function (a) {
    return a.id;
  })]);
  var result = React.useMemo(function () {
    return Belt_Option.orElse(Belt_Option.orElse(activeCategory, rootCategory), firstProductCategory$1);
  }, [activeCategory, settings.indexNode, firstProductCategory$1]);
  React.useEffect(function () {
    Curry._1(setCurrentCategory, function (previous) {
      return Belt_Option.orElse(result, previous);
    });
  }, [result]);
  return React.useMemo(function () {
    return Category$Showside.setChildren(Belt_Option.getWithDefault(currentCategory, LegacyShowside_CategoryDecoders$ApiTypes.empty), []);
  }, [currentCategory]);
}
function useFeaturedProductsSlides(loadedFeaturedProductsOpt, featuredProductsIds, productId, variantId) {
  var loadedFeaturedProducts = loadedFeaturedProductsOpt !== undefined ? loadedFeaturedProductsOpt : [];
  return Belt_Array.keepMap(Belt_Array.mapWithIndex(featuredProductsIds, function (order, id) {
    return PDPTypes$Showside.Slide.makeUnloadedProductSlide(true, id, order);
  }), function (slide) {
    var match = Belt_Array.getBy(loadedFeaturedProducts, function (product) {
      return product.id === PDPTypes$Showside.Slide.getId(slide);
    });
    if (loadedFeaturedProducts.length === 0 && match === undefined) {
      return slide;
    }
    if (match !== undefined) {
      return PDPTypes$Showside.Slide.makeProductSlide(true, variantId, PDPTypes$Showside.Slide.getOrder(slide), match);
    }
  });
}
function useSlides(productId, variantId, pagesOpt, param) {
  var pages = pagesOpt !== undefined ? pagesOpt : [];
  var total = Belt_Option.getWithDefault(Belt_Array.get(Belt_Array.keepMap(pages, function (page) {
    return page.total;
  }), 0), 0);
  var arg = PDPTypes$Showside.Slide.makePlaceholderSlide;
  var initialSlides = Belt_Array.makeBy(total, function (eta) {
    return Curry._3(arg, undefined, undefined, eta);
  });
  return React.useMemo(function () {
    return PDPTypes$Showside.trimTrailingPlaceholders(Belt_Array.reduce(pages, initialSlides, function (slides, page) {
      var offset = Belt_Option.getWithDefault(page.page.offset, 0);
      var leftSlides = Belt_Array.slice(slides, 0, offset);
      var middleSlides = Belt_Array.mapWithIndex(page.products, function (i, product) {
        return PDPTypes$Showside.Slide.makeProductSlide(undefined, variantId, offset + i | 0, product);
      });
      var rightSlides = Belt_Array.sliceToEnd(slides, offset);
      return Belt_Array.mapWithIndex(Belt_Array.concat(Belt_Array.concat(leftSlides, middleSlides), rightSlides), function (i, slide) {
        return PDPTypes$Showside.Slide.setOrder(slide, i);
      });
    }));
  }, [Belt_Array.flatMap(pages, function (page) {
    return page.products;
  }).length, variantId]);
}
function useProductFromCategory(category, settings, productId, variantId) {
  var match = EntrypointContext$Showside.use(undefined);
  var market = match.market;
  var smartnavApiHost = match.smartnavApiHost;
  Markets$Showside.getValues(market);
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var productFilters = match$1.productFilters;
  var relatedProductId = match$1.relatedProductId;
  var listPageType = match$1.listPageType;
  var match$2 = ConfigurationProvider$Showside.use(undefined);
  var match$3 = match$2.config;
  var account = match$3.transitiveAccount;
  var storeId = match$3.transitiveStoreId;
  var storeConnection = Category$Showside.ExternalConnection.getStoreCategoryConnection(category);
  var match$4 = Category$Showside.ExternalConnection.getConnection(category);
  var listPageType$1;
  if (match$4 !== undefined && typeof match$4 === "number") {
    switch (match$4) {
      case /* History */0:
        listPageType$1 = /* History */1;
        break;
      case /* Favorites */1:
        listPageType$1 = /* Favorites */0;
        break;
      case /* StoreCart */2:
        listPageType$1 = /* StoreCart */2;
        break;
    }
  } else {
    listPageType$1 = listPageType;
  }
  var defaultFilters = Belt_Option.flatMap(storeConnection, function (connection) {
    return Category$Showside.ExternalConnection.getFilterBy(connection, account);
  });
  var match$5 = UseApi$Showside.useProductById(Belt_Option.isSome(storeConnection), settings.hideOutOfStock, category.id, smartnavApiHost, market, Belt_Option.getWithDefault(productId, ""));
  var productFromImmediateCache = match$5.product;
  var featuredProductsIds = React.useMemo(function () {
    if (Belt_Option.isNone(productFilters)) {
      return Category$Showside.getProductIds(category);
    } else {
      return [];
    }
  }, []);
  var focalProductId = React.useMemo(function () {
    if (Belt_Array.some(featuredProductsIds, function (id) {
      return Caml_obj.equal(id, productId);
    })) {
      return;
    } else {
      return productId;
    }
  }, []);
  var match$6 = UseApi$Showside.useCategoryProducts(true, storeId, category.id, storeConnection, settings.hideOutOfStock, productFilters, defaultFilters, 10, match$1.productSort, Belt_Option.isSome(storeConnection), smartnavApiHost, focalProductId, market, undefined);
  var connectedDirection = match$6.direction;
  var setConnectedDirection = match$6.setDirection;
  var connectedProductsSwr = match$6.swr;
  var match$7 = SWRUtils$Showside.getPageInfo(connectedProductsSwr, function (page) {
    return page.page.next;
  }, function (page) {
    return page.products;
  });
  var connectedProductsTotal = Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.flatMap(connectedProductsSwr.data, function (pages) {
    return Belt_Array.getBy(pages, function (page) {
      return page.total !== undefined;
    });
  }), function (page) {
    return page.total;
  }), 0);
  var match$8 = SWRUtils$Showside.useRateLimitedPagination(connectedProductsSwr, 3);
  var setConnectedNumPages = match$8.setSize;
  var connectedNumPages = match$8.size;
  var match$9 = UseApi$Showside.useProductsById(storeId, featuredProductsIds, false, true, category.id, smartnavApiHost, market, undefined);
  var loadedFeaturedProducts = match$9.products;
  var relatedProductsSwr = UseApi$Showside.useRelatedProducts(relatedProductId, storeId, category.id, settings.hideOutOfStock, Belt_Option.isNone(storeConnection), smartnavApiHost, market, undefined);
  var match$10 = SWRUtils$Showside.getPageInfo(relatedProductsSwr, function (page) {
    return page.page.next;
  }, function (page) {
    return page.products;
  });
  var match$11 = SWRUtils$Showside.useRateLimitedPagination(relatedProductsSwr, 3);
  var match$12 = UserSavedProductsContent$Showside.useUserSavedProducts(settings.hideOutOfStock, Caml_obj.equal(listPageType$1, /* History */1), true, undefined, "history");
  var historyProducts = match$12.products;
  var match$13 = UserSavedProductsContent$Showside.useUserSavedProducts(settings.hideOutOfStock, Caml_obj.equal(listPageType$1, /* Favorites */0), true, undefined, "favorites");
  var favoriteProducts = match$13.products;
  var match$14 = UserSavedProductsContent$Showside.useUserSavedProducts(settings.hideOutOfStock, Caml_obj.equal(listPageType$1, /* StoreCart */2), true, undefined, "cart");
  var cartProducts = match$14.products;
  var match$15;
  var exit = 0;
  if (listPageType$1 !== undefined && typeof listPageType$1 === "number") {
    switch (listPageType$1) {
      case /* Favorites */0:
        match$15 = [Belt_Option.map(favoriteProducts, IntermediateProductsResponse$Showside.Page.makeVirtualPages), Belt_Option.isSome(favoriteProducts), 1, function (param) {
          return true;
        }, Belt_Option.getWithDefault(Belt_Option.map(favoriteProducts, function (prim) {
          return prim.length;
        }), 0), function (param) {}, undefined];
        break;
      case /* History */1:
        match$15 = [Belt_Option.map(historyProducts, IntermediateProductsResponse$Showside.Page.makeVirtualPages), Belt_Option.isSome(historyProducts), 1, function (param) {
          return true;
        }, Belt_Option.getWithDefault(Belt_Option.map(historyProducts, function (prim) {
          return prim.length;
        }), 0), function (param) {}, undefined];
        break;
      case /* StoreCart */2:
        match$15 = [Belt_Option.map(cartProducts, IntermediateProductsResponse$Showside.Page.makeVirtualPages), Belt_Option.isSome(cartProducts), 1, function (param) {
          return true;
        }, Belt_Option.getWithDefault(Belt_Option.map(cartProducts, function (prim) {
          return prim.length;
        }), 0), function (param) {}, undefined];
        break;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    match$15 = relatedProductId !== undefined ? [relatedProductsSwr.data, match$10.reachedEnd, match$11.size, match$11.setSize, Belt_Option.getWithDefault(Belt_Option.map(match$10.contents, function (prim) {
      return prim.length;
    }), 0), function (param) {}, relatedProductsSwr.error] : storeConnection !== undefined ? [connectedProductsSwr.data, match$7.reachedEnd, connectedNumPages, setConnectedNumPages, connectedProductsTotal, setConnectedDirection, connectedProductsSwr.error] : [undefined, Belt_Option.isSome(loadedFeaturedProducts), 1, function (param) {
      return true;
    }, Belt_Option.getWithDefault(Belt_Option.map(loadedFeaturedProducts, function (prim) {
      return prim.length;
    }), 0), function (param) {}, match$9.error];
  }
  var error = match$15[6];
  var total = match$15[4];
  var featuredSlides = useFeaturedProductsSlides(loadedFeaturedProducts, featuredProductsIds, productId, variantId);
  var slides = useSlides(productId, variantId, match$15[0], undefined);
  var slides$1 = React.useMemo(function () {
    if (slides.length !== 0) {
      return PDPTypes$Showside.Slides.dedupById(Belt_Array.concat(featuredSlides, slides));
    } else {
      return PDPTypes$Showside.Slides.dedupById(Belt_Array.concat(featuredSlides, Belt_Array.map(Belt_Array.keepMap([productFromImmediateCache], function (a) {
        return a;
      }), function (product) {
        return PDPTypes$Showside.Slide.makeProductSlide(undefined, variantId, 0, product);
      })));
    }
  }, [featuredSlides, slides, productFromImmediateCache, variantId]);
  var position = Belt_Option.getWithDefault(Belt_Array.getIndexBy(slides$1, function (slide) {
    switch (slide.TAG | 0) {
      case /* Product */0:
        return Caml_obj.equal(slide.product.id, productId);
      case /* Placeholder */1:
      case /* UnloadedProduct */2:
        return false;
    }
  }), 0);
  var currentSlideIndex = Belt_Array.getIndexBy(slides$1, function (slide) {
    return PDPTypes$Showside.Slide.getId(slide) === productId;
  });
  React.useEffect(function () {
    if (currentSlideIndex !== undefined) {
      var closestLeftPlaceholderIndex = Caml.int_max(Belt_Array.map(slides$1.slice(0, currentSlideIndex), function (slide) {
        switch (slide.TAG | 0) {
          case /* Placeholder */1:
            return true;
          case /* Product */0:
          case /* UnloadedProduct */2:
            return false;
        }
      }).lastIndexOf(true), 0);
      var closestRightPlaceholderIndex = Caml.int_max(Belt_Array.map(slides$1, function (slide) {
        switch (slide.TAG | 0) {
          case /* Placeholder */1:
            return true;
          case /* Product */0:
          case /* UnloadedProduct */2:
            return false;
        }
      }).indexOf(true, currentSlideIndex), 0);
      var currentSlideIndexRelativeToLeftPlaceholder = currentSlideIndex - closestLeftPlaceholderIndex | 0;
      var tooCloseToLeft = currentSlideIndexRelativeToLeftPlaceholder < 10 && closestLeftPlaceholderIndex > 0;
      var tooCloseToRight = (closestRightPlaceholderIndex - currentSlideIndex | 0) < 10;
      var exit = 0;
      if (tooCloseToRight && connectedDirection <= 0) {
        Curry._1(setConnectedDirection, 1);
        Curry._1(setConnectedNumPages, connectedNumPages + 1 | 0);
      } else {
        exit = 1;
      }
      if (exit === 1) {
        if (tooCloseToLeft && connectedDirection >= 0) {
          Curry._1(setConnectedDirection, -1);
          Curry._1(setConnectedNumPages, connectedNumPages + 1 | 0);
        } else {
          Curry._1(setConnectedDirection, 0);
        }
      }
    }
  }, [currentSlideIndex]);
  return React.useMemo(function () {
    return {
      position: position,
      total: total,
      slides: slides$1,
      error: error
    };
  }, [position, total, slides$1, error]);
}
function usePDPPagination(quickViewConfig, category, settings, productId, variantId) {
  var match = RouterProvider$Showside.useRouter(undefined);
  var isInsideQuickView = match.isQuickView;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var quickView = match$1.raw.quickView;
  var config = useProductFromCategory(category, settings, productId, variantId);
  var match$2 = quickView.mediaId;
  var media = quickViewConfig !== undefined && match$2 !== undefined ? QuickViewTypes$Showside.mediaById(quickViewConfig, match$2) : undefined;
  return React.useMemo(function () {
    if (!isInsideQuickView) {
      return config;
    }
    if (media === undefined) {
      return config;
    }
    if (quickViewConfig === undefined) {
      return config;
    }
    var products = Belt_Array.reduce(Curry._2(QuickViewTypes$Showside.productsInMedia, quickViewConfig, media), [], function (acc, curr) {
      var found = Belt_Array.some(acc, function (media) {
        return media.id === curr.id;
      });
      if (found) {
        return acc;
      } else {
        return Belt_Array.concat(acc, [curr]);
      }
    });
    var total = products.length;
    var position = Belt_Array.getIndexBy(products, function (p) {
      return Caml_obj.equal(p.id, productId);
    });
    if (position !== undefined) {
      return {
        position: position,
        total: total,
        slides: Belt_Array.mapWithIndex(products, function (order, product) {
          return PDPTypes$Showside.Slide.makeProductSlide(undefined, variantId, order, product);
        }),
        error: undefined
      };
    } else {
      return config;
    }
  }, [PDPTypes$Showside.getKey(config), quickViewConfig, quickView.mediaId, isInsideQuickView, variantId]);
}
function UsePDPPagination$DebugViewer(Props) {
  var currentProductId = Props.currentProductId;
  var data = Props.data;
  var store = StoreProvider$Showside.use(undefined);
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var route = match.route;
  var goToProduct = React.useCallback(function (productId) {
    return function (variantId) {
      if (typeof route === "number") {
        return;
      }
      switch (route.TAG | 0) {
        case /* PDP */2:
          var pdpRoute = route._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* PDP */2,
            _0: {
              categoryId: pdpRoute.categoryId,
              productCategoryId: pdpRoute.productCategoryId,
              productId: productId,
              variantId: variantId,
              zoomedPhotoIndex: pdpRoute.zoomedPhotoIndex
            }
          });
        case /* QuickView */3:
          var qvRoute = route._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* QuickView */3,
            _0: {
              mediaId: qvRoute.mediaId,
              mediaParentId: qvRoute.mediaParentId,
              albumId: qvRoute.albumId,
              productId: productId,
              relatedMediaProductIds: qvRoute.relatedMediaProductIds,
              relatedMediaCategoryId: qvRoute.relatedMediaCategoryId,
              variantId: variantId,
              panelClosed: qvRoute.panelClosed,
              zoomedPhotoIndex: qvRoute.zoomedPhotoIndex,
              time: qvRoute.time
            }
          });
        default:
          return;
      }
    };
  }, []);
  return React.createElement("div", {
    className: CSS$Showside.prefix("absolute bottom-0 left-0 w-full overflow-auto flex bg-black bg-opacity-80 gap-2"),
    style: {
      zIndex: "2147483647"
    }
  }, React.createElement("h1", {
    className: CSS$Showside.prefix("text-red-200 text-4xl sticky left-0 top-0")
  }, "Debug Viewer"), Belt_Array.mapWithIndex(data, function (i, slide) {
    var tmp;
    switch (slide.TAG | 0) {
      case /* Product */0:
        tmp = slide.product.id === currentProductId ? "opacity-100 bg-red-200 w-8 cursor-pointer" : "opacity-50 bg-white w-4 cursor-pointer";
        break;
      case /* Placeholder */1:
        tmp = "opacity-25 bg-transparent w-4";
        break;
      case /* UnloadedProduct */2:
        tmp = "opacity-25 bg-white w-4";
        break;
    }
    var tmp$1;
    switch (slide.TAG | 0) {
      case /* Product */0:
        var product = slide.product;
        tmp$1 = "" + Product$Showside.getDisplayName(store, product.firstVariant, product) + " (" + String(i + 1 | 0) + " / " + String(data.length) + ")";
        break;
      case /* Placeholder */1:
        tmp$1 = "Placeholder (" + String(i + 1 | 0) + " / " + String(data.length) + ")";
        break;
      case /* UnloadedProduct */2:
        tmp$1 = "Loading... '" + slide.id + "' (" + String(i + 1 | 0) + " / " + String(data.length) + ")";
        break;
    }
    return React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.callbackDomRef(function (el) {
        if (el == null) {
          return;
        }
        switch (slide.TAG | 0) {
          case /* Product */0:
            if (slide.product.id === currentProductId) {
              SmoothScrollIntoViewIfNeeded(el, {
                behavior: "smooth",
                block: "nearest",
                inline: "center",
                scrollMode: "always"
              });
              return;
            } else {
              return;
            }
          case /* Placeholder */1:
          case /* UnloadedProduct */2:
            return;
        }
      }),
      className: CSS$Showside.prefix(Cn.make(["rounded h-3 border border-solid border-white transition-all duration-300", tmp, "flex-shrink-0"])),
      title: tmp$1,
      onClick: function (param) {
        switch (slide.TAG | 0) {
          case /* Product */0:
            return Curry._2(goToProduct, slide.product.id, slide.variant.id);
          case /* Placeholder */1:
          case /* UnloadedProduct */2:
            return;
        }
      }
    });
  }));
}
UsePDPPagination$DebugViewer.displayName = "UsePDPPagination.DebugViewer";
var DebugViewer = {
  make: UsePDPPagination$DebugViewer
};
export { isShopifyCollectionId, useProductCategory, useFeaturedProductsSlides, useSlides, useProductFromCategory, usePDPPagination, DebugViewer };
/* react Not a pure module */